import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import {
  kitchenHeaderCardModalContent,
  kitchenHeaderCardModalText,
  kitchenHeaderCardModalTitle,
} from '../../kitchen-header-card-styles';

export const Done = () => (
  <>
    <ModalHeader className={kitchenHeaderCardModalTitle} title="Реализовано более 1&nbsp;млн проектов" />
    <ModalContent className={kitchenHeaderCardModalContent}>
      <Typography className={kitchenHeaderCardModalText} variant="m" size="body_long">
        Более 1&nbsp;млн реализованных проектов за&nbsp;10&nbsp;лет.
      </Typography>
      <Typography variant="m" size="body_long">
        Мы&nbsp;&mdash; эксперты в&nbsp;проектировании и&nbsp;производстве кухонь. Создаём решения, которые
        гармонично сочетаются с&nbsp;вашим стилем и&nbsp;бюджетом, сохраняя главные принципы&nbsp;&mdash;
        индивидуальный подход и&nbsp;доступные цены.
      </Typography>
    </ModalContent>
  </>
);
